export default __webpack_public_path__ + "static/media/contato.f52e94e2.png";